import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1daa1d89"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-lg container-fluid shadow-sm py-3" }
const _hoisted_2 = { ref: "innovation2" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, [
  /*#__PURE__*/_createTextVNode(" C. Impact "),
  /*#__PURE__*/_createElementVNode("small", { class: "span_color" }, "(Information to describe the solution's impact, viability, sustainability, potential to scale and further development requirements).")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "impact" }, [
  /*#__PURE__*/_createTextVNode("Describe the solution's impact to date, or potential impact to be achieved (250 words max)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contextType" }, [
  /*#__PURE__*/_createTextVNode("In what type of context does the solution have impact or relevancy"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "context" }, [
  /*#__PURE__*/_createTextVNode("Describe the context (250 words max)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tested" }, [
  /*#__PURE__*/_createTextVNode("Has the solution been tested in Africa for viability"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "testProcess" }, [
  /*#__PURE__*/_createTextVNode(" If yes, which country(s) has it been tested in? Explain the process of testing the solution and the results thereof"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "criticalProcess" }, [
  /*#__PURE__*/_createTextVNode("What are the next critical steps you need to take to get to the next level, and what support is required. (Please give detail - this can include, staff, skill, manufacturing, funding, etc requirements) (250 words max)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "potential" }, [
  /*#__PURE__*/_createTextVNode("What is the potential for scale? (250 words max)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "challenges" }, [
  /*#__PURE__*/_createTextVNode("What are the challenges for going to scale? (250 words max)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, [
  /*#__PURE__*/_createTextVNode(" D. Information and Legal "),
  /*#__PURE__*/_createElementVNode("small", { class: "span_color" }, "(Information regarding applicant opinions/recommendations, applicant's bio/profile, confidentiality and IP statements).")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "selfDescription" }, [
  /*#__PURE__*/_createTextVNode("Please write a short description about yourself, your qualification, study and work background, as well as your relationship to the solution and your role with regards to its continued development (250 words max)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_18 = { class: "terms" }
const _hoisted_19 = { for: "privacyPolicy" }
const _hoisted_20 = { for: "intellectualProperty" }
const _hoisted_21 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_BaseFileLong = _resolveComponent("BaseFileLong")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_TermsAndConditions = _resolveComponent("TermsAndConditions")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Intellectual = _resolveComponent("Intellectual")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.impact,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.impact) = $event)),
          id: "impact",
          name: "impact",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"]),
        _hoisted_7,
        _createVNode(_component_Dropdown, {
          id: "contextType",
          name: "contextType",
          modelValue: _ctx.form.contextType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.contextType) = $event)),
          options: _ctx.contextTypeProp,
          optionLabel: "id",
          optionValue: "id",
          placeholder: "Select option...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue", "options"]),
        _hoisted_8,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.context,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.context) = $event)),
          id: "context",
          name: "context",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"]),
        _hoisted_9,
        _createVNode(_component_Dropdown, {
          id: "tested",
          name: "tested",
          modelValue: _ctx.form.tested,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.tested) = $event)),
          options: _ctx.testedProp,
          optionLabel: "id",
          optionValue: "id",
          placeholder: "Select option...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue", "options"]),
        (_ctx.form.tested === 'Yes')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_Textarea, {
                modelValue: _ctx.form.testProcess,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.testProcess) = $event)),
                id: "testProcess",
                name: "testProcess",
                autoResize: true,
                rows: "5",
                cols: "30",
                placeholder: "Enter text here...",
                class: "w-100 mb-3"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _hoisted_12,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.criticalProcess,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.criticalProcess) = $event)),
          id: "criticalProcess",
          name: "criticalProcess",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"]),
        _hoisted_13,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.potential,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.potential) = $event)),
          id: "potential",
          name: "potential",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"]),
        _hoisted_14,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.challenges,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.challenges) = $event)),
          id: "challenges",
          name: "challenges",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_15,
        _hoisted_16,
        _hoisted_17,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.selfDescription,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.selfDescription) = $event)),
          id: "selfDescription",
          name: "selfDescription",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_BaseFileLong, {
          value: _ctx.fileProp1,
          fileOne: _ctx.file1,
          "onUpdate:fileOne": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.file1) = $event))
        }, null, 8, ["value", "fileOne"]),
        _createVNode(_component_BaseFileLong, {
          value: _ctx.fileProp2,
          fileTwo: _ctx.file2,
          "onUpdate:fileTwo": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.file2) = $event))
        }, null, 8, ["value", "fileTwo"]),
        _createVNode(_component_BaseFileLong, {
          value: _ctx.fileProp3,
          fileThree: _ctx.file3,
          "onUpdate:fileThree": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.file3) = $event))
        }, null, 8, ["value", "fileThree"]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", null, [
            _createVNode(_component_Checkbox, {
              id: "privacyPolicy",
              name: "privacyPolicy",
              value: "privacyPolicy",
              modelValue: _ctx.form.privacyPolicy,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.privacyPolicy) = $event)),
              class: "mx-1"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_19, [
              _createTextVNode("I have read and accepted the "),
              _createVNode(_component_router_link, {
                to: "#",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.termsModal = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Privacy policy & Confidential Non-Disclosure Clause")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("span", null, [
            _createVNode(_component_Checkbox, {
              id: "intellectualProperty",
              name: "intellectualProperty",
              value: "intellectualProperty",
              modelValue: _ctx.form.intellectualProperty,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.intellectualProperty) = $event)),
              class: "mx-1"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_20, [
              _createTextVNode("I have read and accepted the "),
              _createVNode(_component_router_link, {
                to: "#",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.intellectualModal = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Intellectual Property statement")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_BaseButton, {
          type: "button",
          onClick: _withModifiers(_ctx.updatePage, ["prevent"]),
          customStyle: _ctx.btnStyle
        }, {
          default: _withCtx(() => [
            _createTextVNode("Prev Page")
          ]),
          _: 1
        }, 8, ["onClick", "customStyle"]),
        _createVNode(_component_BaseButton, {
          customStyle: _ctx.btnStyle1,
          type: "button",
          onClick: _ctx.saveForLater
        }, {
          default: _withCtx(() => [
            _createTextVNode("Save for later")
          ]),
          _: 1
        }, 8, ["customStyle", "onClick"]),
        _createVNode(_component_BaseButton, {
          disabled: _ctx.loading,
          class: _normalizeClass({ submitting: _ctx.loading }),
          customStyle: _ctx.buttonStyle,
          type: "button",
          onClick: _ctx.submitPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("Submit for approval")
          ]),
          _: 1
        }, 8, ["disabled", "class", "customStyle", "onClick"])
      ])
    ], 512),
    _createVNode(_component_Dialog, {
      visible: _ctx.termsModal,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.termsModal) = $event)),
      style: { width: '50rem' },
      breakpoints: { '600px': '85vw' },
      modal: true,
      header: " ",
      dismissableMask: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TermsAndConditions)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.intellectualModal,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.intellectualModal) = $event)),
      style: { width: '50rem' },
      breakpoints: { '600px': '85vw' },
      modal: true,
      header: " ",
      dismissableMask: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Intellectual)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}